import { EA_TRAVEL_RATES_AUTH_FORM_SET_VALUE } from '../../../actions/eaTravelRates/auth';
import { authFormValidation } from './auth';

import { EA_TRAVEL_RATES_UPDATE_FORM_SET_VALUE } from '../../../actions/eaTravelRates/update';
import { updateFormValidation } from './update';

export const eaTravelRatesValidation = (store, next, action) => {
    if (action.type.startsWith(EA_TRAVEL_RATES_AUTH_FORM_SET_VALUE)) {
        return authFormValidation(store, next, action);
    }

    if (action.type.startsWith(EA_TRAVEL_RATES_UPDATE_FORM_SET_VALUE)) {
        return updateFormValidation(store, next, action);
    }

    return null;
};
